import SearchParamsBase from '../../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../../Helpers/datetimeHelper';
import AuthService from '../../../../Services/authService';
import OfficeHelper from '../../../../Helpers/ModelHelpers/OfficeHelper';

export default class OpenAssignmentSearchParams extends SearchParamsBase {
  initialize() {
    this.ClientNameOrId = '';
    this.SurveyNameOrId = '';
    this.WaveNameOrId = '';
    this.ProjectNameOrId = '';
    this.LocationNameOrId = '';
    this.CountryIds = [];
    this.Scheduler = '';
    this.UseDueDateRange = false;
    this.DueDateAfter = dateTimeHelper.indefiniteDateValue();
    this.DueDateBefore = dateTimeHelper.indefiniteDateValue();
    this.OfficeId = OfficeHelper.GetDefaultOfficeIds(OpenAssignmentSearchParams.getUserOffice());
    this.NoClient = false;
    this.NoProject = false;
  }

  static fieldsInSearchBox = [
    { fieldName: 'CountryIds', label: 'Countries', className: 'col-4', type: InputTypesEnum.CountryMultiChoice },
    { fieldName: 'UseDueDateRange', label: 'Use Due Date Range', className: 'col-4', type: InputTypesEnum.OnOff },
    {
      fieldName: 'DueDateAfter',
      label: 'Due Date After',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDueDateRange,
    },
    {
      fieldName: 'DueDateBefore',
      label: 'Due Date Before',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDueDateRange,
    },
    { fieldName: 'Scheduler', label: 'Scheduler', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'OfficeId', label: 'Office', className: 'col-4', type: InputTypesEnum.OfficeOrGroupSelect },
    { fieldName: 'LocationNameOrId', label: 'Location Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'NoClient', label: 'No Client', className: 'col-4', type: InputTypesEnum.Checkbox },
    {
      fieldName: 'ClientNameOrId',
      label: 'Client Name or ID',
      className: 'col-4',
      type: InputTypesEnum.Text,
      disabled: (item) => item.NoClient,
    },
    {
      fieldName: 'SurveyNameOrId',
      label: 'Survey Name or ID',
      className: 'col-4',
      type: InputTypesEnum.Text,
      disabled: (item) => item.NoClient,
    },
    {
      fieldName: 'NoProject',
      label: 'No Project',
      className: 'col-4',
      type: InputTypesEnum.Checkbox,
      disabled: (item) => item.NoClient,
    },
    {
      fieldName: 'WaveNameOrId',
      label: 'Wave Name or ID',
      className: 'col-4',
      type: InputTypesEnum.Text,
      disabled: (item) => item.NoClient,
    },
    {
      fieldName: 'ProjectNameOrId',
      label: 'Project Name or ID',
      className: 'col-4',
      type: InputTypesEnum.Text,
      disabled: (item) => item.NoProject || item.NoClient,
    },
  ];

  static getUserOffice() {
    const user = AuthService.getInstance().GetLoggedInUser();
    return user.officeId;
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'OpenAssignmentSearchParams';
}
